import React from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import { Logo } from "../components/Logo";

// SAS AUPREA - Informations légales
const C = {
  raison_sociale: "AUPREA",
  forme: "Société par actions simplifiée (SAS)",
  siret: "933 283 459 00016",
  siren: "933 283 459",
  adresse: "Les Tivoli N°28, rue Joseph Ignace, 97112 Grand-Bourg, Guadeloupe",
  directeur: "Charles NEBOT",
  email: "contact@auprea.com",
  rcs: "RCS Pointe-à-Pitre · SIREN 933 283 459",
};

const PAGES = {
  "mentions-legales": {
    title: "Mentions légales",
    content: (
      <>
        <h2>Éditeur du site</h2>
        <p>Le site <strong>www.auprea.com</strong> est édité par :</p>
        <ul>
          <li><strong>Raison sociale</strong> : {C.raison_sociale}</li>
          <li><strong>Forme juridique</strong> : {C.forme}</li>
          <li><strong>SIRET</strong> : {C.siret}</li>
          <li><strong>Immatriculation</strong> : {C.rcs}</li>
          <li><strong>Siège social</strong> : {C.adresse}</li>
          <li><strong>Directeur de la publication</strong> : {C.directeur}</li>
          <li><strong>Contact</strong> : <a href={`mailto:${C.email}`}>{C.email}</a></li>
        </ul>

        <h2>Hébergement</h2>
        <p>
          Le site est hébergé par <strong>Emergent</strong> (infrastructure cloud située en Union Européenne).
          Les données utilisateurs sont stockées sur des serveurs européens conformément au RGPD.
        </p>

        <h2>Propriété intellectuelle</h2>
        <p>
          L'ensemble des éléments de ce site (textes, images, logo, charte graphique, code source)
          est la propriété exclusive d'AUPREA, sauf mention contraire. Toute reproduction, même partielle,
          est interdite sans autorisation écrite préalable.
        </p>

        <h2>Limitation de responsabilité</h2>
        <p>
          AUPREA est un outil d'aide à l'anticipation patrimoniale et successorale.
          Il ne se substitue en aucun cas aux conseils d'un notaire, avocat, conseiller en gestion
          de patrimoine ou tout autre professionnel du droit. Les utilisateurs sont seuls responsables
          de la véracité et de l'exactitude des informations qu'ils saisissent dans leur carnet.
        </p>

        <h2>Droit applicable</h2>
        <p>
          Le présent site est régi par le droit français. En cas de litige, et après échec d'une
          tentative de résolution amiable, compétence exclusive est attribuée aux tribunaux français.
        </p>
      </>
    ),
  },
  "cgu": {
    title: "Conditions Générales d'Utilisation",
    content: (
      <>
        <h2>1. Objet</h2>
        <p>
          Les présentes CGU régissent l'utilisation du site <strong>www.auprea.com</strong> et de
          l'ensemble des services proposés par {C.raison_sociale}. En créant un compte ou en
          naviguant sur le site, l'utilisateur accepte sans réserve les présentes conditions.
        </p>

        <h2>2. Description du service</h2>
        <p>
          AUPREA met à disposition un outil de carnet patrimonial numérique permettant à l'utilisateur :
        </p>
        <ul>
          <li>de renseigner son identité, sa famille, son patrimoine et ses volontés successorales ;</li>
          <li>de stocker des documents personnels dans un coffre-fort sécurisé ;</li>
          <li>de partager certaines rubriques en lecture seule à un professionnel (notaire, CGP) ;</li>
          <li>de bénéficier d'alertes intelligentes sur sa situation successorale.</li>
        </ul>

        <h2>3. Accès au service</h2>
        <p>
          L'accès au service nécessite la création d'un compte avec une adresse e-mail valide
          et un mot de passe sécurisé (8 caractères minimum). L'utilisateur est seul responsable
          de la confidentialité de ses identifiants.
        </p>

        <h2>4. Engagements de l'utilisateur</h2>
        <ul>
          <li>Fournir des informations exactes, complètes et à jour ;</li>
          <li>Ne pas utiliser le service à des fins illicites ;</li>
          <li>Ne pas tenter d'accéder aux données d'un autre utilisateur ;</li>
          <li>Avertir AUPREA de toute utilisation frauduleuse de son compte.</li>
        </ul>

        <h2>5. Responsabilité</h2>
        <p>
          AUPREA met en œuvre tous les moyens raisonnables pour assurer la disponibilité et la
          sécurité du service. Toutefois, AUPREA ne saurait être tenu responsable :
        </p>
        <ul>
          <li>d'une interruption temporaire du service pour maintenance ;</li>
          <li>de l'inexactitude des informations saisies par l'utilisateur ;</li>
          <li>des conséquences juridiques liées à une transmission patrimoniale.</li>
        </ul>
        <p>
          AUPREA est un outil de préparation et de centralisation, et ne remplace en aucun cas
          l'intervention d'un professionnel du droit (notaire, avocat).
        </p>

        <h2>6. Résiliation</h2>
        <p>
          L'utilisateur peut supprimer son compte à tout moment depuis l'espace Sécurité de son
          carnet. La suppression entraîne l'effacement définitif de toutes ses données dans un
          délai de 30 jours.
        </p>

        <h2>7. Modification des CGU</h2>
        <p>
          AUPREA se réserve le droit de modifier les présentes CGU à tout moment. Les utilisateurs
          seront notifiés par e-mail des modifications substantielles.
        </p>
      </>
    ),
  },
  "cgv": {
    title: "Conditions Générales de Vente",
    content: (
      <>
        <h2>1. Identification du vendeur</h2>
        <p>
          Les présentes CGV régissent les ventes réalisées par {C.raison_sociale}, {C.forme},
          dont le siège social est situé {C.adresse}, immatriculée au {C.rcs}, SIRET {C.siret}.
        </p>

        <h2>2. Forfaits proposés</h2>
        <ul>
          <li><strong>Découverte</strong> : gratuit, accès limité (Identité, Famille)</li>
          <li><strong>Essentiel</strong> : 19,90 € TTC/mois ou 199,00 € TTC/an (2 mois offerts)</li>
          <li><strong>Confort</strong> : 29,99 € TTC/mois ou 299,90 € TTC/an (2 mois offerts)</li>
        </ul>
        <p>
          Les prix sont indiqués en euros, toutes taxes comprises (TVA française applicable selon
          le régime fiscal du vendeur). Le détail des fonctionnalités est précisé sur la page
          <Link to="/tarifs"> Tarifs</Link>.
        </p>

        <h2>3. Modalités de paiement</h2>
        <p>
          Les paiements sont sécurisés et traités par <strong>Stripe</strong>, prestataire de
          paiement certifié PCI-DSS. AUPREA ne stocke jamais les informations bancaires.
          Les cartes bancaires acceptées : Visa, Mastercard, American Express.
        </p>

        <h2>4. Droit de rétractation</h2>
        <p>
          Conformément à l'article L.221-28 du Code de la consommation, le droit de rétractation
          ne peut être exercé pour les prestations de services pleinement exécutées avant la fin
          du délai de rétractation et dont l'exécution a commencé après accord exprès du
          consommateur. En souscrivant à un forfait, le client demande expressément la fourniture
          immédiate du service et renonce à son droit de rétractation.
        </p>
        <p>
          Cependant, à titre commercial, AUPREA accepte un remboursement intégral en cas de
          demande dans les 7 jours suivant la première souscription, sur demande à
          <a href={`mailto:${C.email}`}> {C.email}</a>.
        </p>

        <h2>5. Résiliation de l'abonnement</h2>
        <p>
          L'utilisateur peut résilier son abonnement à tout moment depuis la page
          <Link to="/abonnement"> Abonnement</Link>. La résiliation prend effet à la fin
          de la période en cours déjà payée. Aucun remboursement n'est effectué pour la
          période entamée.
        </p>

        <h2>6. Données personnelles</h2>
        <p>
          Le traitement des données est régi par notre
          <Link to="/legal/confidentialite"> Politique de confidentialité</Link>, conforme au RGPD.
        </p>

        <h2>7. Litiges</h2>
        <p>
          En cas de litige, le client peut, à titre gratuit, recourir à un médiateur de la
          consommation. À défaut d'accord amiable, les tribunaux français seront seuls compétents.
        </p>
      </>
    ),
  },
  "confidentialite": {
    title: "Politique de confidentialité (RGPD)",
    content: (
      <>
        <h2>1. Responsable du traitement</h2>
        <p>
          {C.raison_sociale}, {C.forme}, située {C.adresse}, est responsable du traitement de
          vos données personnelles. Pour toute question : <a href={`mailto:${C.email}`}>{C.email}</a>.
        </p>

        <h2>2. Données collectées</h2>
        <p>Nous collectons :</p>
        <ul>
          <li><strong>Données d'identification</strong> : nom, prénom, email, mot de passe (chiffré)</li>
          <li><strong>Données du carnet</strong> : informations sur votre famille, votre patrimoine,
            vos volontés, vos documents — saisies volontairement par vous</li>
          <li><strong>Données de connexion</strong> : adresse IP, navigateur, journal des connexions</li>
          <li><strong>Données de paiement</strong> : traitées exclusivement par Stripe (jamais stockées chez nous)</li>
        </ul>

        <h2>3. Finalités du traitement</h2>
        <ul>
          <li>Fournir le service de carnet patrimonial</li>
          <li>Gérer votre compte et votre abonnement</li>
          <li>Détecter et prévenir les fraudes</li>
          <li>Vous envoyer des informations sur le service (newsletter, sur opt-in uniquement)</li>
        </ul>

        <h2>4. Base légale</h2>
        <ul>
          <li><strong>Exécution du contrat</strong> : gestion du compte et de l'abonnement</li>
          <li><strong>Consentement</strong> : newsletter, cookies analytiques</li>
          <li><strong>Obligations légales</strong> : conservation comptable, lutte contre la fraude</li>
        </ul>

        <h2>5. Durée de conservation</h2>
        <ul>
          <li>Données du compte : durée de l'abonnement + 3 ans après résiliation</li>
          <li>Données de paiement (preuves) : 10 ans (obligation comptable)</li>
          <li>Journal des connexions : 12 mois</li>
          <li>Newsletter : jusqu'au désabonnement</li>
        </ul>

        <h2>6. Vos droits</h2>
        <p>Conformément au RGPD, vous disposez des droits suivants :</p>
        <ul>
          <li><strong>Accès</strong> à vos données (export JSON disponible dans l'espace Sécurité)</li>
          <li><strong>Rectification</strong> directement depuis votre carnet</li>
          <li><strong>Suppression</strong> de votre compte et de toutes vos données (espace Sécurité)</li>
          <li><strong>Portabilité</strong> au format JSON</li>
          <li><strong>Opposition</strong> au traitement à des fins marketing</li>
          <li><strong>Limitation</strong> du traitement</li>
        </ul>
        <p>
          Pour exercer ces droits : <a href={`mailto:${C.email}`}>{C.email}</a>. En cas de litige,
          vous pouvez introduire une réclamation auprès de la CNIL (<a href="https://www.cnil.fr" target="_blank" rel="noreferrer">www.cnil.fr</a>).
        </p>

        <h2>7. Sécurité</h2>
        <p>
          AUPREA met en œuvre les mesures suivantes pour protéger vos données :
        </p>
        <ul>
          <li>Mots de passe chiffrés (bcrypt)</li>
          <li>Connexions HTTPS sur l'ensemble du site</li>
          <li>Coffre-fort documents en accès restreint (authentification obligatoire)</li>
          <li>Journalisation des accès</li>
          <li>Hébergement dans l'Union Européenne</li>
          <li>Authentification à deux facteurs disponible pour l'administration</li>
        </ul>

        <h2>8. Sous-traitants</h2>
        <p>Nous faisons appel aux sous-traitants suivants, tous conformes au RGPD :</p>
        <ul>
          <li><strong>Stripe</strong> (paiements) — certifié PCI-DSS</li>
          <li><strong>SendGrid / Twilio</strong> (e-mails transactionnels) — Data Processing Agreement signé</li>
          <li><strong>Google Analytics</strong> (mesure d'audience, IP anonymisée)</li>
          <li><strong>Emergent</strong> (hébergement Union Européenne)</li>
        </ul>

        <h2>9. Cookies</h2>
        <p>
          Le site utilise des cookies essentiels (authentification) et des cookies analytiques
          (Google Analytics avec IP anonymisée). Vous pouvez refuser les cookies non-essentiels
          via le bandeau de consentement.
        </p>
      </>
    ),
  },
};

export default function LegalPage() {
  const { slug } = useParams();
  const page = PAGES[slug];
  if (!page) return <Navigate to="/legal/mentions-legales" replace />;

  return (
    <div className="min-h-screen" style={{ backgroundColor: "var(--auprea-cream)" }}>
      <nav className="flex items-center justify-between px-6 md:px-12 py-6 border-b" style={{ borderColor: "rgba(21,41,79,0.1)" }}>
        <Link to="/"><Logo size={28} /></Link>
        <Link to="/" className="text-sm" style={{ color: "var(--auprea-blue)" }}>← Retour au site</Link>
      </nav>
      <section className="px-6 md:px-12 lg:px-24 py-16 max-w-3xl mx-auto">
        <div style={{ color: "var(--auprea-gold)", fontSize: 12, letterSpacing: "0.2em", textTransform: "uppercase", fontWeight: 600, marginBottom: 16 }}>
          — Informations légales
        </div>
        <h1 style={{ fontSize: "clamp(2rem, 4vw, 2.75rem)", marginBottom: 12 }}>{page.title}</h1>
        <p style={{ color: "rgba(35,38,46,0.5)", fontSize: 13, marginBottom: 32 }}>
          Dernière mise à jour : {new Date().toLocaleDateString("fr-FR")}
        </p>
        <article className="legal-content" style={{ lineHeight: 1.75, fontSize: 16 }}>
          {page.content}
        </article>

        <div className="mt-16 pt-8 border-t" style={{ borderColor: "rgba(21,41,79,0.1)" }}>
          <div style={{ fontSize: 13, color: "rgba(35,38,46,0.6)", textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 8 }}>
            Autres documents légaux
          </div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/legal/mentions-legales" style={{ color: "var(--auprea-blue)" }}>Mentions légales</Link>
            <Link to="/legal/cgu" style={{ color: "var(--auprea-blue)" }}>CGU</Link>
            <Link to="/legal/cgv" style={{ color: "var(--auprea-blue)" }}>CGV</Link>
            <Link to="/legal/confidentialite" style={{ color: "var(--auprea-blue)" }}>Politique de confidentialité</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
